exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_object-gops.js
// module id = 71
// module chunks = 0